import { render, staticRenderFns } from "./DetailAwaCompany.vue?vue&type=template&id=cbf89f00"
import script from "./DetailAwaCompany.vue?vue&type=script&lang=js"
export * from "./DetailAwaCompany.vue?vue&type=script&lang=js"
import style0 from "./DetailAwaCompany.vue?vue&type=style&index=0&id=cbf89f00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports